module.exports = __webpack_public_path__ + "static/media/Icon_off.361d9b25.svg";